// extracted by mini-css-extract-plugin
export default {"homeSection":"Home_homeSection__hfLzm","title":"Home_title__jVDou","subtitle":"Home_subtitle__LOKDC"};